export default "__VITE_ASSET__DwDX_a1Q__"